/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * Server, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminSettingsDto,
  DatabaseAdminOperation
} from '../models';

import { customInstance } from '../../../orvalCustomAxiosInstance';
import type { ErrorType } from '../../../orvalCustomAxiosInstance';




/**
 * Apply any pending database migrations
 */
export const postApiAdminSettingsMigrate = (

 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/AdminSettings/migrate`, method: 'POST', signal
    },
      );
    }



export const getPostApiAdminSettingsMigrateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminSettingsMigrate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdminSettingsMigrate>>, TError,void, TContext> => {

const mutationKey = ['postApiAdminSettingsMigrate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdminSettingsMigrate>>, void> = () => {


          return  postApiAdminSettingsMigrate()
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdminSettingsMigrateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdminSettingsMigrate>>>

    export type PostApiAdminSettingsMigrateMutationError = ErrorType<unknown>

    export const usePostApiAdminSettingsMigrate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminSettingsMigrate>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdminSettingsMigrate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostApiAdminSettingsMigrateMutationOptions(options), queryClient);
    }
    /**
 * Get the current state of the database including migration details.
 */
export const getApiAdminSettings = (

 signal?: AbortSignal
) => {


      return customInstance<AdminSettingsDto>(
      {url: `/api/AdminSettings`, method: 'GET', signal
    },
      );
    }




export const getGetApiAdminSettingsQueryKey = () => {
    return [
    `/api/AdminSettings`
    ] as const;
    }


export const getGetApiAdminSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminSettings>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminSettings>>> = ({ signal }) => getApiAdminSettings(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAdminSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminSettings>>>
export type GetApiAdminSettingsQueryError = ErrorType<unknown>


export function useGetApiAdminSettings<TData = Awaited<ReturnType<typeof getApiAdminSettings>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdminSettings>>,
          TError,
          Awaited<ReturnType<typeof getApiAdminSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdminSettings<TData = Awaited<ReturnType<typeof getApiAdminSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdminSettings>>,
          TError,
          Awaited<ReturnType<typeof getApiAdminSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdminSettings<TData = Awaited<ReturnType<typeof getApiAdminSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAdminSettings<TData = Awaited<ReturnType<typeof getApiAdminSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAdminSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Clean the database by deleting all data and building a new clean copy with latest migrations applied.
 */
export const postApiAdminSettingsClean = (

 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/AdminSettings/clean`, method: 'POST', signal
    },
      );
    }



export const getPostApiAdminSettingsCleanMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminSettingsClean>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdminSettingsClean>>, TError,void, TContext> => {

const mutationKey = ['postApiAdminSettingsClean'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdminSettingsClean>>, void> = () => {


          return  postApiAdminSettingsClean()
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdminSettingsCleanMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdminSettingsClean>>>

    export type PostApiAdminSettingsCleanMutationError = ErrorType<unknown>

    export const usePostApiAdminSettingsClean = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminSettingsClean>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdminSettingsClean>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostApiAdminSettingsCleanMutationOptions(options), queryClient);
    }
    /**
 * Add and save the current testing/development seed data set to the database.
 */
export const postApiAdminSettingsSeedDev = (

 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/AdminSettings/seed/dev`, method: 'POST', signal
    },
      );
    }



export const getPostApiAdminSettingsSeedDevMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminSettingsSeedDev>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiAdminSettingsSeedDev>>, TError,void, TContext> => {

const mutationKey = ['postApiAdminSettingsSeedDev'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAdminSettingsSeedDev>>, void> = () => {


          return  postApiAdminSettingsSeedDev()
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAdminSettingsSeedDevMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAdminSettingsSeedDev>>>

    export type PostApiAdminSettingsSeedDevMutationError = ErrorType<unknown>

    export const usePostApiAdminSettingsSeedDev = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAdminSettingsSeedDev>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAdminSettingsSeedDev>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostApiAdminSettingsSeedDevMutationOptions(options), queryClient);
    }
    /**
 * Get details for Database Administration operations.
 */
export const getApiAdminSettingsOptions = (

 signal?: AbortSignal
) => {


      return customInstance<DatabaseAdminOperation[]>(
      {url: `/api/AdminSettings/options`, method: 'GET', signal
    },
      );
    }




export const getGetApiAdminSettingsOptionsQueryKey = () => {
    return [
    `/api/AdminSettings/options`
    ] as const;
    }


export const getGetApiAdminSettingsOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiAdminSettingsOptions>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSettingsOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAdminSettingsOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAdminSettingsOptions>>> = ({ signal }) => getApiAdminSettingsOptions(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSettingsOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAdminSettingsOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAdminSettingsOptions>>>
export type GetApiAdminSettingsOptionsQueryError = ErrorType<unknown>


export function useGetApiAdminSettingsOptions<TData = Awaited<ReturnType<typeof getApiAdminSettingsOptions>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSettingsOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdminSettingsOptions>>,
          TError,
          Awaited<ReturnType<typeof getApiAdminSettingsOptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdminSettingsOptions<TData = Awaited<ReturnType<typeof getApiAdminSettingsOptions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSettingsOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAdminSettingsOptions>>,
          TError,
          Awaited<ReturnType<typeof getApiAdminSettingsOptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAdminSettingsOptions<TData = Awaited<ReturnType<typeof getApiAdminSettingsOptions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSettingsOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAdminSettingsOptions<TData = Awaited<ReturnType<typeof getApiAdminSettingsOptions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAdminSettingsOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAdminSettingsOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






